import resultApi from './api/resultApi';
import config from "../config";

export const RESULT_GET = 'result/RESULTGET';


const initialState = {

}

export default (state = initialState, action) => {
    switch (action.type) {
        case RESULT_GET:
            return {
                ...state,
                resultData: action.payload,
            };

       

        default:
            return state;
    }
}

export const resultGet = (payload) => {
    return dispatch => {
        return resultApi.ResultGet().then(data => {
            dispatch({
                type: RESULT_GET,
                payload: data,
            });
            return data;
        })
            .catch(err => {
                throw (err)
            })
    }
}

export const resultDreamSearch = (input) => {
    // return dispatch => {
         return resultApi.resultDreamSearch(input).then(data => {
            // console.log(data)
            // dispatch({
            //     type: RESULT_DREAM_SEARCH,
            //     payload: data,
            // });
            return data;
        })
            .catch(err => {
                throw (err)
            })
    // }
}

export const resultDreamDetailGet = (input) => {
    // return dispatch => {
        return resultApi.resultDreamDetailGet(input).then(data => {
            // dispatch({
            //     type: RESULT_DREAM_DETAIL,
            //     payload: data,
            // });
            return data;
        })
            .catch(err => {
                throw (err)
            })
    // }
}

export const resultSuggestDetailGet = (input) => {
    // return dispatch => {
        return resultApi.resultSuggestDetailGet(input).then(data => {
            // dispatch({
            //     type: RESULT_DREAM_DETAIL,
            //     payload: data,
            // });
            return data;
        })
            .catch(err => {
                throw (err)
            })
    // }
}

export const mainpageJobGet = () => {
    // return dispatch => {
        return resultApi.mainpageJobGet().then(data => {
            // dispatch({
            //     type: RESULT_DREAM_DETAIL,
            //     payload: data,
            // });
            return data;
        })
            .catch(err => {
                throw (err)
            })
    // }
}

export const getStudentReport = (payload) => {
    return dispatch => {
        return resultApi.getStudentReport().then(data => {
            return data;
        }).catch(err => {
            throw (err)
        })
    }
}

export const getAverageData = () => {
    return resultApi.getAverageData().then(data => {
        return data;
    }).catch(err => {
        throw (err)
    })
}

export const getReportEmail = (payload) => {
  return dispatch => {
    return resultApi.getReportEmail(payload).then(data => {
        return data;
    }).catch(err => {
        throw (err)
    })
}
}
